import { Component, ViewEncapsulation, OnInit, ViewContainerRef, ViewChild, ElementRef } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW4500Model } from './kymw4500.model';
import { KYMW4501Component } from '../kymw4501/kymw4501.component';
import { KYMW4502Component } from '../kymw4502/kymw4502.component';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';
import { GetFeatureMasterInfoService } from './api-services/get-feature-master-info.service';
import { GetCatalogFixFlagService } from './api-services/get-catalog-fix-flag.service';
import { GetApprovalFlowListService } from './api-services/get-approval-flow-list.service';
import { Menu } from '@grapecity/wijmo.input';
import { CellRange, CellType, FlexGrid, SelectionMode } from '@grapecity/wijmo.grid';
import { KYMW0002Component } from 'src/app/commons/kymw00/kymw0002/kymw0002.component';
import { KYMW0400Component } from 'src/app/commons/kymw04/kymw0400/kymw0400.component';
import { KYMW0400InputModel } from 'src/app/commons/kymw04/kymw0400/vo/kymw0400-input.model';
import { KYMW0400OutputModel } from 'src/app/commons/kymw04/kymw0400/vo/kymw0400-output.model';
import { OrderCodeTextInputComponent } from 'src/app/commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { PlessAlert } from 'src/app/shared/pless-alert/pless-alert.component';
import { Router } from '@angular/router';
import { GetNotificationUserListService } from './api-services/get-notification-user-list.service';
import { GetFixFeatureForMasterInfoService } from './api-services/get-fix-feature-for-master-info.service';
import { UpdateFeatureMasterInfoService } from './api-services/update-feature-master.service';
import { GetMediumGroupDivService } from './api-services/get-medium-group-div.service';
import { MediumTypeComboBoxComponent } from 'src/app/commons/kymw02/combo-box/medium-type-combo-box/medium-type-combo-box.component';
import { KYMW0003Component } from 'src/app/commons/kymw00/kymw0003/kymw0003.component';
import { GetCycleMediumSelectItemsService } from '../../kymw12/kymw1200/api-services/get-cycle-medium-select-items.service';
import { KYMW1200Model } from '../../kymw12/kymw1200/kymw1200.model';

/**
 * 特集マスタ画面を管理するクラス
 *
 * @export KYMW4500Component
 * @class KYMW4500Component
 */
@Component({
  selector: 'app-kymw4500',
  templateUrl: 'kymw4500.component.html',
  styleUrls: ['kymw4500.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW4500Component extends PlessViewHelperSub implements OnInit {
  public kymw4500Model: KYMW4500Model = new KYMW4500Model();
  private contextMenu: Menu;
  private editingTarget: string;
  // 権限取得
  private isFullControl = this.getFuncPermission('KYMW4500') === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL;
  // サイクル設定のモデル
  public kymw1200Model: KYMW1200Model = new KYMW1200Model();

  MAX_COUNT = 100;

  @ViewChild('btn_Add', { static: true }) btn_Add: ElementRef;
  @ViewChild('btn_Save', { static: true }) btn_Save: ElementRef;
  @ViewChild('btn_PageEdit', { static: true }) btn_PageEdit: ElementRef;
  @ViewChild('dtg_SpecialFeature', { static: true }) dtg_SpecialFeature: FlexGrid;
  @ViewChild('txti_OrderCode', { static: true }) txti_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('cmb_MediumType', { static: true }) public cmb_MediumType: MediumTypeComboBoxComponent = null;

  /**
   * Creates an instance of KYMW4500Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ViewContainerRef} viewContainerRef
   * @param {kymw4500Model} kymw4500Model
   * @memberof KYMW4500Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    public viewContainerRef: ViewContainerRef,
    public kymw00Model: KYMW00Model,
    private getFeatureMasterInfoService: GetFeatureMasterInfoService,
    private getCatalogFixFlagService: GetCatalogFixFlagService,
    private getApprovalFlowListService: GetApprovalFlowListService,
    private getNotificationUserListService: GetNotificationUserListService,
    private getFixFeatureForMasterInfoService: GetFixFeatureForMasterInfoService,
    private updateFeatureMasterInfoService: UpdateFeatureMasterInfoService,
    private getMediumGroupDivService: GetMediumGroupDivService,
    private router: Router,
    private elementRef: ElementRef,
    private getCycleMediumSelectItemsService: GetCycleMediumSelectItemsService,
  ) {
    super(kymw00Model);

    
  }

  /**
   * 初期表示
   */
  public ngOnInit(): void {
    //活性・非活性制御
    if (!this.isFullControl) {    // 「2：フルコントロール」以外の場合
      this.kymw4500Model.specialFeatureCopyBtnDisabled = true;
      this.kymw4500Model.btnImageMakeInstructionDisabled = true;
      this.kymw4500Model.btnImageAllRegistDisabled = true;
      this.kymw4500Model.saveBtnDisabled = true;
      this.kymw4500Model.addBtnDisabled = true;
    }

    // サイクル設定で選択できる媒体を取得（kymw1200.cycleMediumList）
    this.getCycleMediumSelectItemsService.executeAsync(this.kymw1200Model);

    this.contextMenu = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          {
            header: 'タグ選択', caption: 'タグ選択', cmd: 'selectTag'
          },
          {
            header: '取引先選択', caption: '取引先選択', cmd: 'selectPayeeSupplier'
          },
          {
            header: '企画支援選択', caption: '企画支援選択', cmd: 'selectAssociatedCompany'
          },
          {
            header: '削除', caption: '削除', cmd: 'deleteRow'
          }
        ],
        command: this.getFormatContextMenuCommand(),
        // イベント設定
        itemClicked: () => {
          switch (this.contextMenu.selectedValue) {
            case 'selectTag':
              this.eventClickHandler_SelectTag();
              break;
            case 'selectPayeeSupplier':
              this.eventClickHandler_SelectPayeeSupplier();
              break;
            case 'selectAssociatedCompany':
              this.eventClickHandler_SelectAssociatedCompany();
              break;
            case 'deleteRow':
              this.eventClickHandler_DeleteRow();
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_SpecialFeature.hostElement.addEventListener('contextmenu', (e: any) => {
      e.preventDefault();
      if (this.contextMenu !== undefined) {
        const ht = this.dtg_SpecialFeature.hitTest(e.pageX, e.pageY);
        if (ht.cellType === CellType.Cell) {
          // 右クリック押下時に対象行を選択状態にする
          const selectedRow = new CellRange(ht.row, ht.col);
          this.dtg_SpecialFeature.select(selectedRow, false);

          // コンテキストメニューの活性・非活性制御
          let enableSelectTag = true;
          let enableSelectPayeeSupplier = true;
          let enableSelectAssociatedCompany = true;
          let enableDeleteRow = true;

          // 企画担当商品選定済 もしくは 企画回確定済 もしくは 媒体未選択 もしくは フルコントロール以外の場合はすべて非活性
          if (this.dtg_SpecialFeature.selectedItems[0].PlannerSelectionFlag === '1' || !this.isEditable || !this.isFullControl) {
            enableSelectTag = false;
            enableSelectPayeeSupplier = false;
            enableSelectAssociatedCompany = false;
            enableDeleteRow = false;
          } else {
            // 媒体が「在庫限定」の場合は企画支援を非活性
            if (this.kymw4500Model.mediumGroupDiv === '10') {
              enableSelectAssociatedCompany = false;
            }

            // 媒体毎必須特集フラグ=TRUEの場合は削除を非活性
            if (this.dtg_SpecialFeature.selectedItems[0].FeaturePerMediaFlag === 'true') {
              enableDeleteRow = false;
            }

            // 「企画支援会社」が設定済みの場合は企画支援選択、削除を非活性
            if (this.dtg_SpecialFeature.selectedItems[0].AssociatedCompanyExsist) {
              enableSelectAssociatedCompany = false;
              enableDeleteRow = false;
            }

            // 「取引先」が設定済みの場合は削除を非活性
            if (!PlessViewUtilsSub.isEmptyArray(this.dtg_SpecialFeature.selectedItems[0].PayeeSupplierList)) {
              enableDeleteRow = false;
            }

            // サイクル設定で選択できる媒体ではない場合、取引先選択、企画支援選択を非活性
            const kymw1200MediumList = this.kymw1200Model.cycleMediumList.map(_ => _.Code);
            if (!kymw1200MediumList.includes(this.dtg_SpecialFeature.selectedItems[0].MediumType)) {
              enableSelectPayeeSupplier = false;
              enableSelectAssociatedCompany = false;
            }
          }

          this.contextMenu.itemsSource[0].enabled = enableSelectTag;
          this.contextMenu.itemsSource[1].enabled = enableSelectPayeeSupplier;
          this.contextMenu.itemsSource[2].enabled = enableSelectAssociatedCompany;
          this.contextMenu.itemsSource[3].enabled = enableDeleteRow;

          this.contextMenu.show(e);
          return;
        }
        this.contextMenu.hide();
      }
    });

    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[0]);
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[1]);
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[2]);
    this.initForcedEnabledForContextMenuItemByScreenMode(this.contextMenu.itemsSource[3]);
  }

  /**
   * メニュー項目活性・非活性制御
   *
   * @private
   * @returns
   * @memberof KYMW4500Component
   */
  private getFormatContextMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        return (param.enabled === false) ? false : true;
      }
    };
  }

  /**
   * 表示ボタン押下時
   */
  public eventClickHandler_Display() {
    // 受注コード・存在チェック
    if (PlessViewUtilsSub.isEmpty(this.kymw4500Model.catalogId)) {
      this.dialogService.openAlertGetMessage('W0001', ['企画回']);
      return;
    }
    if (this.kymw4500Model.catalogId.length !== 8 || !PlessViewUtilsSub.isIntString(this.kymw4500Model.catalogId)) {
      this.dialogService.openAlertGetMessage('E0113', ['企画回の入力内容'], null);
      return;
    }

    // 承認フロー区分セレクトリスト項目取得
    this.getApprovalFlowListService.execute(this.kymw4500Model);
    // 通知受領担当者セレクトリスト項目取得
    this.getNotificationUserListService.execute(this.kymw4500Model);
    // 特集マスタ情報取得
    this.getFeatureMasterInfo();
    // 企画確定フラグ取得APIを呼び出す
    this.getCatalogFixFlagService.execute(this.kymw4500Model);

    // 媒体入力時は媒体区分取得
    if (!PlessViewUtilsSub.isEmpty(this.kymw4500Model.mediumType)) {
      this.getMediumGroupDivService.execute(this.kymw4500Model);
    } else {
      this.kymw4500Model.mediumGroupDiv = '';
    }
  }

  getFeatureMasterInfo() {
    // 特集マスタ情報取得APIを呼び出す
    this.getFeatureMasterInfoService.execute(this.kymw4500Model, (data) => {
      // 特集マスタ情報取得API実行時刻をセッションに保存する。
      this.kymw4500Model.exclusiveDatetime = data.ExclusiveDatetime;
      if (this.kymw4500Model.featureList.length === 0) {
        // 結果が0件の場合、固定特集情報を表示する。
        this.getFixFeatureForMasterInfoService.execute(this.kymw4500Model, (data) => {
          // 固定特集情報も0件の場合はデータなしメッセージ
          if (data.length != 0) {
            this.dialogService.openAlertGetMessage('I0514', null,
              (closeDetail) => {
                if (closeDetail === PlessAlert.Yes) {
                  this.kymw4500Model.setGetFixFeatureForMasterInfoList(data);
                  this.dtg_SpecialFeature.collectionView.refresh();
                }
              });
          } else {
            this.dialogService.openAlertGetMessage('E0100');
          }
        });
        return;
      }

      // 企画回のみ入力された場合各ボタンを非活性化
      if (PlessViewUtilsSub.isEmpty(this.kymw4500Model.mediumType)) {
        this.kymw4500Model.isOnlyCatalogId = true;
        return;
      }

      this.kymw4500Model.isOnlyCatalogId = false;
    });
  }

  /**
   * 企画回の値を変更したとき
   */
  eventBlurHandler_CatalogId() {
    this.clearFeatureList();
  }

  /**
   * 受注コードの値を変更したとき
   */
  eventBlurHandler_OrderCode() {
    this.clearFeatureList();
  }

  /**
   * 媒体の値を変更したとき
   */
  eventBlurHandler_MediumType() {
    this.clearFeatureList();
  }

  /**
   * 一覧表示を初期化する
   */
  clearFeatureList() {
    this.kymw4500Model.featureList = [];
    this.kymw4500Model.catalogFixFlag = true;
  }

  /**
   * タグ選択
   */
  eventClickHandler_SelectTag() {
    // タグ選択画面で選択したタグに更新する
    const selectedItem = this.dtg_SpecialFeature.selectedRows[0]?.dataItem;
    const selectedIndex = this.dtg_SpecialFeature.selectedRows[0]?.index;
    const componentRef = this.dialogService.openModal(KYMW0002Component);
    const instance = componentRef.componentInstance as KYMW0002Component;
    instance.parent = this;
    instance.setParams(selectedItem.TagList.map(_ => _.TagId));
    instance.closeFunction = () => {
      componentRef.close();
      const params = instance.getParams();
      if (!params) return;
      const updatedTagList = params.map(_ => {
        return {
          TagId: _.tagId,
          TagName: _.tagName
        }
      });
      this.kymw4500Model.featureList[selectedIndex].TagList = updatedTagList;
      this.kymw4500Model.featureList[selectedIndex].Tags = updatedTagList.map(_ => _.TagName).join(', ');
      this.dtg_SpecialFeature.collectionView.refresh();
    };
  }

  /**
   * 取引先選択
   */
  eventClickHandler_SelectPayeeSupplier() {
    // 取引先選択画面で選択した取引先に更新する
    const selectedIndex = this.dtg_SpecialFeature.selectedRows[0]?.index;
    const vo: KYMW0400InputModel = new KYMW0400InputModel();
    vo.supplierFlg = '1'; // 支払先
    vo.isMultiCheckable = true; // 複数選択
    const PayeeSuppliers = this.kymw4500Model.featureList[selectedIndex].PayeeSuppliers;
    const PayeeSuppliersList = PayeeSuppliers && PayeeSuppliers.trim() !== '' ? PayeeSuppliers.split(', ').map(item => {
        const [code, name] = item.split(':');
        return { supplierCode: code, supplierNameKanji: name };
      }) : [];
    vo.multiSuppliers = PayeeSuppliersList;
    const componentRef = this.dialogService.openModal(KYMW0400Component);
    const instance = componentRef.componentInstance as KYMW0400Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0400Parameter = (outputVO: KYMW0400OutputModel) => {
      this.kymw4500Model.featureList[selectedIndex].PayeeSupplierList =
        outputVO.multiSuppliers.map(_ => {
          return {
            PayeeSupplierCode: _.supplierCode,
            PayeeSupplierName: _.supplierNameKanji
          }
        })
      this.kymw4500Model.featureList[selectedIndex].PayeeSuppliers =
        this.kymw4500Model.featureList[selectedIndex].PayeeSupplierList
          .map(_ => `${_.PayeeSupplierCode}:${_.PayeeSupplierName}`).join(', ');
      this.dtg_SpecialFeature.collectionView.refresh();
    };
    instance.closeFunction = () => {
      componentRef.close();
    };
  }


  /**
   * 特集名を編集する
   * @param $event
   */
  // 編集前の特集名を取得
  eventChangingHandler_FeatureName(cell) {
    this.editingTarget = cell.item.FeatureName;
  }
  // 編集後の入力チェック
  eventChangeHandler_FeatureName(cell) {
    const beforeInput = this.editingTarget;
    // 特集名必須・属性チェック
    if (PlessViewUtilsSub.isEmpty(cell.item.FeatureName)) {
      this.dialogService.openAlertGetMessage('W0001', ['特集名'], () => {
        // 編集前の特集名に戻す
        cell.item.FeatureName = beforeInput;
      });
      return;
    }
  }

  /**
   * 企画支援選択
   */
  eventClickHandler_SelectAssociatedCompany() {
    // 企画支援先選択画面を呼び出す
    const selectedIndex = this.dtg_SpecialFeature.selectedRows[0]?.index;
    const componentRef = this.dialogService.openModal(KYMW0003Component);
    const instance = componentRef.componentInstance as KYMW0003Component;
    instance.parent = this;
    instance.closeFunction = () => {
      const outputVO = instance.getParams();
      if (outputVO) {
        this.kymw4500Model.featureList[selectedIndex].AssociatedCompanyId = outputVO.associatedCompanyId;
        this.kymw4500Model.featureList[selectedIndex].AssociatedCompanyName = outputVO.associatedCompanyName;
      }
      componentRef.close();
      this.dtg_SpecialFeature.collectionView.refresh();
    };
  }

  /**
   * 行削除
   */
  eventClickHandler_DeleteRow() {
    // 確認ダイアログを表示して「はい」なら削除する
    const selectedItem = this.dtg_SpecialFeature.selectedRows[0]?.dataItem;
    const selectedIndex = this.dtg_SpecialFeature.selectedRows[0]?.index;
    this.dialogService.openAlertGetMessage('Q0176', ['特集コード：' + selectedItem.FeatureCode],
      (closeDetail) => {
        if (closeDetail === PlessAlert.Yes) {
          this.kymw4500Model.featureList.splice(selectedIndex, 1);
          this.dtg_SpecialFeature.collectionView.refresh();
        }
      }
    );
  }

  /**
   * 行追加
   */
  eventClickHandler_Add() {
    // ・「特集コード」は「媒体コード」3桁＋「連番」2桁で構成される。
    // ・「連番」は00～99まで順番に付与し、存在していない番号を設定する。
    let seqFeatureCode = '';
    const featureCodes = this.kymw4500Model.featureList.map(_ => _.FeatureCode);
    for (const seqNum in [...Array(100)]) {
      seqFeatureCode = this.kymw4500Model.mediumType + PlessViewUtilsSub.padding(`${seqNum}`, 2, '0', 1);
      if (featureCodes.includes(seqFeatureCode)) {
        continue;
      }
      break;
    }
    this.kymw4500Model.featureList.push({
      OrderCode: '',
      DelivCatalogId: this.kymw4500Model.catalogId,
      MediumType: this.cmb_MediumType.selectedMediumType,
      MediumName: this.cmb_MediumType.selectedMediumName,
      FeatureCode: seqFeatureCode,
      FeatureName: '',
      ApprovalFlowType: '0',
      ApprovalFlowTypeName: '通常承認',
      NotificationUserId: '',
      NotificationUserName: '',
      PlannerSelectionFlag: '0',
      AssociatedCompanyId: '',
      AssociatedCompanyName: '',
      Remarks: '',
      FeaturePerMediaFlag: '',
      TagList: [],
      PayeeSupplierList: []
    });
    this.dtg_SpecialFeature.collectionView.refresh();
  }

  /**
   * 特集コピーボタン押下時
   */
  public eventClickHandler_SpecialFeatureCopy() {
    if (!this.txti_OrderCode.isValidOrderCode()) {
      this.dialogService.openAlertGetMessage('E0113', ['企画回の入力内容'], null);
      return;
    }

    this.getCatalogFixFlagService.execute(this.kymw4500Model, () => {
      if (this.kymw4500Model.catalogFixFlag) {
        this.dialogService.openAlertGetMessage('E0604', null, null);
        return;
      } else {
        // 対象の特集が編集中(DB未保存)の場合、確認ダイアログを表示する
        if (this.isFeaturesModified()) {
          this.dialogService.openAlertGetMessage('Q0177', null,
            (closeDetail) => {
              if (<number>closeDetail === <number>PlessAlert.Yes) {
                // 特集コピー画面を呼び出す
                const componentRef = this.dialogService.openModal(KYMW4502Component);
                const instance = componentRef.componentInstance as KYMW4502Component;
                instance.parent = this;
                instance.kymw4502Model.orderCode = this.kymw4500Model.orderCode;
                instance.kymw4502Model.delivCatalogId = this.kymw4500Model.catalogId;
                instance.closeFunction = () => {
                  // 特集コピー画面から復帰したときモーダル画面表示前の検索条件で再検索する
                  // 1-1-1. 前回検索条件がある場合は再検索
                  // 1-1-2. 前回検索条件がない場合は検索しない
                  // 受注コード・存在チェック
                  if (!PlessViewUtilsSub.isEmpty(this.kymw4500Model.catalogId)) {
                    this.eventClickHandler_Display();
                  }
                  componentRef.close();
                };
              }
            });
          return;
        }
        // 特集コピー画面を呼び出す
        const componentRef = this.dialogService.openModal(KYMW4502Component);
        const instance = componentRef.componentInstance as KYMW4502Component;
        instance.parent = this;
        instance.kymw4502Model.orderCode = this.kymw4500Model.orderCode;
        instance.kymw4502Model.delivCatalogId = this.kymw4500Model.catalogId;
        instance.closeFunction = () => {
          // 特集コピー画面から復帰したときモーダル画面表示前の検索条件で再検索する
          // 1-1-1. 前回検索条件がある場合は再検索
          // 1-1-2. 前回検索条件がない場合は検索しない
          // 受注コード・存在チェック
          if (!PlessViewUtilsSub.isEmpty(this.kymw4500Model.catalogId)) {
            this.eventClickHandler_Display();
          }
          componentRef.close();
        };
      }
    });
  }

  private isFeaturesModified() {
    // 編集中かどうかをチェックする
    if (this.kymw4500Model.featureList.length === this.kymw4500Model.pureFeatureList.length) {
      for (const idx in this.kymw4500Model.pureFeatureList) {
        if (JSON.stringify(this.kymw4500Model.pureFeatureList[idx]) != JSON.stringify(this.kymw4500Model.featureList[idx])) {
          return true;
        }
      }
      return false;
    }
    return true;
  }

  /**
   * ページ・台割編集ボタン押下
   */
  public eventClickHandler_OpenPageEdit() {
    //  ページ・台割編集画面へ遷移
    this.router.navigate(['/kymw/4400']);
  }

  /**
   * 固定特集一覧表示ボタン押下時
   */
  public eventClickHandler_FixedSpecialFeatureList() {
    // 固定特集一覧表示画面を呼び出す
    const componentRef = this.dialogService.openModal(KYMW4501Component);
    const instance = componentRef.componentInstance as KYMW4501Component;
    instance.parent = this;
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 保存ボタン押下
   */
  async eventClickHandler_Save() {
    // 「特集名」が未入力の場合は、エラーメッセージ「特集名が入力されていません」を表示する。		
    for (const _ of this.kymw4500Model.featureList) {
      if (PlessViewUtilsSub.isEmpty(_.FeatureName)) {
        this.dialogService.openAlertGetMessage('W0001', ['特集名']);
        return;
      }
      if (_.FeatureName.length > 30) {
        this.dialogService.openAlertGetMessage('W0005', ['特集名', '30']);
        return;
      }
      if (_.FeatureName.length > 256) {
        this.dialogService.openAlertGetMessage('W0005', ['備考', '256']);
        return;
      }
    }

    // 特集マスタ更新
    // 企画担当商品選定済フラグが「0:選定未完了」のみが対象
    const updateFeatureList = this.kymw4500Model.featureList.filter(
      item => item.PlannerSelectionFlag === '0'
    );

    this.updateFeatureMasterInfoService.execute(Array.from(updateFeatureList.values()), this.kymw4500Model, () => {
      this.dialogService.openAlertGetMessage('I0513', null,
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            this.getFeatureMasterInfo();
          }
        });
    });
  }

  get isMaxCount() {
    return this.kymw4500Model.featureList.length >= this.MAX_COUNT;
  }

  get isEditable() {
    return !this.kymw4500Model.catalogFixFlag && !PlessViewUtilsSub.isEmpty(this.kymw4500Model.mediumType) && this.isFullControl;
  }
}
